import request from '@/utils/request'

// 新增商家绑定域名
export function addDomain(data) {
  return request({
    url: '/server/domain/add',
    method: 'post',
    data: data
  })
}
// 查询商家绑定域名列表
export function getDomainList(data) {
  return request({
    url: '/server/domain/list',
    method: 'get',
    params: data
  })
}

// 查询部门详细
export function auditDomain(data) {
  return request({
    url: '/server/domain/audit',
    method: 'post',
    data: data
  })
}